import { OktaAuth } from '@okta/okta-auth-js'
import {
  SetAuthState,
  onError,
  clearLocalStorage,
  handleSegment,
  redirectOnSuccess,
} from '.'
import { AUTH_STATE } from '../../enums/auth-state'
import {
  getAuthProvider,
  ThriveAuthProviders,
  setAuthProvider,
  getCachedUserData,
  handleThriveUserId,
  removeOktaFlow,
} from '../../util/thrive-user-data'
import { AppErrorDispatchType } from '../AppError'

import { getCurrentUserEmail as getCognitoUserEmail } from '../../api/cognito'
import { getCurrentUserEmail as getOktaUserEmail } from '../../api/okta'

const onSuccessAuthentication = async (
  setAuthState: SetAuthState,
  email: string
): Promise<void> => {
  await handleThriveUserId(email)
  handleSegment(getCachedUserData())
  removeOktaFlow()
  redirectOnSuccess(setAuthState)
}

const onFailureAuthentication = async (setAuthState: SetAuthState) => {
  clearLocalStorage()
  setAuthState(AUTH_STATE.UNAUTHD)
}

/**
 * handle the user's app auth state based on the Amplify auth state
 */
export async function onLoad(
  setAuthState: SetAuthState,
  appErrorDispatch: AppErrorDispatchType,
  oktaAuth: OktaAuth
): Promise<void> {
  try {
    const oktaUserEmail = await getOktaUserEmail(oktaAuth)
    if (!oktaUserEmail && getAuthProvider() === ThriveAuthProviders.okta) {
      onFailureAuthentication(setAuthState)
    }
    if (oktaUserEmail) {
      setAuthProvider(ThriveAuthProviders.okta)
      onSuccessAuthentication(setAuthState, oktaUserEmail)
      return
    }

    const cognitoUserEmail = await getCognitoUserEmail()
    if (cognitoUserEmail) {
      setAuthProvider(ThriveAuthProviders.cognito)
      onSuccessAuthentication(setAuthState, cognitoUserEmail)
      return
    }

    // make the user sign-in again — token expired
    onFailureAuthentication(setAuthState)
  } catch (err) {
    onError(err, setAuthState, appErrorDispatch)
  }
}
